import styled from "styled-components";
import bg from "../../../../assets/images/background.svg";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Wrapper = styled.div`
  width: 80%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
`;

export const Row = styled.div`
  display: flex;
  width: 80%;
  flex-direction: column;
  align-items: center;
`;

export const ComponentWrapper = styled.div`
  width: 100%;
  height: ${(props) => props.height};
  background-color: #1a1a1a;
  background-image: ${bg};
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  margin-top: 3em;

  .summary-stats {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 32px;

    .summary-stat {
      font-size: 14px;
      color: #fff;
      margin-right: 1em;
    }
  }
`;

export const Button = styled.button`
  width: 10em !important;
  height: 10em !important;
  border-radius: 50%;
  background-color: hsl(185, 92%, 17%);
  background-image: ${bg};
  font-size: 14px;
  margin-right: 16px;
  margin-top: 16px;

  &.perception-active {
    background-color: hsl(185, 92%, 61%) !important;
  }

  :hover,
  :active,
  :focus {
    border-radius: 50%;
  }

  :active {
    background-color: hsl(185, 92%, 61%) !important;
  }
`;

export const Heading = styled.h1`
  font: italic bold 2em "Roboto Condensed";
  text-transform: uppercase;
  text-align: center;
  color: #fff;
  margin: 1em 0;
`;

export const Description = styled.p`
  font: italic bold 20px "Roboto Condensed";
  text-align: center;
  text-transform: capitalize;
  color: #fff;
`;



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ViewPerceptions/SchoolPerceptions.styles.ts